import {Pipe, PipeTransform} from '@angular/core';
import {DecimalPipe} from "@angular/common";

@Pipe({
  name: 'decimalPlaces'
})
export class DecimalPlacesPipe implements PipeTransform {

  constructor(private decimalPipe: DecimalPipe) {
  }

  transform(value: number, decimalPlaces: number = 2): string {
    const digitsInfo = `1.${decimalPlaces ?? 2}-${decimalPlaces ?? 2}`;
    return this.decimalPipe.transform(value, digitsInfo) ?? '';
  }
}
